import { apiGet } from '../api'

export const get_performance = query => {
  return apiGet({
    endpoint: `attendance/get_performance?${query}`
  })
}
